import { FlexCol } from '@/components/ui/flex';
import type { FC } from 'react';
import { SourceScrapingPage } from '../../components/RegulatoryWatchAdmin/SourceScrapingPage';

export const AdminScrapePage: FC = () => {
  return (
    <FlexCol gap="6" w="full" h="full" p="6" className="max-w-[1600px]">
      <SourceScrapingPage />
    </FlexCol>
  );
};
